import { render, staticRenderFns } from "./gant.vue?vue&type=template&id=c0fd33fa&scoped=true"
import script from "./gant.vue?vue&type=script&lang=js"
export * from "./gant.vue?vue&type=script&lang=js"
import style0 from "./gant.vue?vue&type=style&index=0&id=c0fd33fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fd33fa",
  null
  
)

export default component.exports